import React from 'react';

var BlogSubscribe = function BlogSubscribe(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, "Subscribe"), /*#__PURE__*/React.createElement("div", {
    className: "blog-subscribe"
  }, /*#__PURE__*/React.createElement("p", null, children)));
};

BlogSubscribe.displayName = 'Blog Subscribe';
var BlogSubscribeDoc;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  BlogSubscribeDoc = require('./doc').doc(BlogSubscribe);
}

var BlogSubscribeWrapper = BlogSubscribeDoc || BlogSubscribe;
export { BlogSubscribeWrapper as BlogSubscribe };